




import {
  defineComponent,
  onMounted,
  onUnmounted,
} from '@nuxtjs/composition-api'
import loadTestografAsync from '@/helpers/loadTestografAsync'
import { useGetYmClientId } from '@/composition/useGetYmClientId'

export default defineComponent({
  name: 'Testograf',
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    messageHandler: {
      type: Function,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { getYmClientId } = useGetYmClientId()

    onMounted(async () => {
      if (!process.browser) return
      if (!(await loadTestografAsync())) return
      const ymClientId = await getYmClientId()
      window.ttgrafSetEmbedParams({
        id: props.id,
        scrollToInvalid: true,
        fixedHeaderHeight: 0,
      })
      const testografParams = {
        alias: window.location.href,
        ...props.data,
      }
      if (ymClientId) {
        testografParams.ym_client_id = ymClientId
      }
      window.testograf = {
        params: testografParams,
      }
      const frameRootElement = document.querySelector('#tte-i-' + props.id)
      const observer = new MutationObserver(() => {
        const frame = document.querySelector('iframe#ttgraf-' + props.id)
        if (!frame) return
        frame.addEventListener('load', () => {
          setTimeout(() => {
            emit('mounted')
          })
        })
      })
      observer.observe(frameRootElement, {
        childList: true,
        subtree: true,
      })
      window.addEventListener('message', props.messageHandler)
    })

    onUnmounted(() => {
      if (process.browser) {
        window.removeEventListener('message', props.messageHandler)
      }
    })
    return {}
  },
})
